<template>
    <div class="modal-footer" :class="{ 'with-navigation': stepIndex > 0 }">
        <button
            class="previous-button"
            :disabled="isPreviousStepLocked"
            @click="previousStep()"
        >
            <i class="fas fa-arrow-left" />
        </button>

        <ProgressBar
            :value="progressBarValue - 1"
            :max="progressBarMax - 1"
            progress-color="#632ADB"
        />
    </div>
</template>
<script>

/**
 * External dependencies.
 */
import { mapState, mapGetters, mapActions } from 'vuex';

/**
 * Internal dependencies.
 */
import { ProgressBar } from '@/components';

export default {
    components: {
        ProgressBar,
    },

    computed: {
        ...mapState('register', {
            recentlyRegistered: state => state.recentlyRegistered,
            registrationStep: state => state.step,
            registrationStepsCount: state => state.stepsCount,
        }),

        ...mapState('show/modal', [
            'isPreviousStepLocked',
        ]),

        ...mapGetters('show/modal', [
            'stepIndex',
            'stepsCount',
        ]),

        /**
         * Gets the progress bar value.
         *
         * @returns {number} Progress bar value.
         */
        progressBarValue() {
            return this.recentlyRegistered
                ? this.registrationStep + this.stepIndex + 1
                : this.stepIndex + 1;
        },

        /**
         * Gets the progress bar max value.
         *
         * @returns {number} Progress bar max value.
         */
        progressBarMax() {
            return this.recentlyRegistered
                ? this.registrationStepsCount + this.stepsCount
                : this.stepsCount;
        },
    },

    methods: {
        ...mapActions('show/modal', [
            'previousStep',
        ]),
    },
};
</script>
<style scoped lang="scss">
    @use './ModalFooter.scss';
</style>
